import PropTypes from "prop-types";
import { compose } from "recompose";

import { Button, Main } from "@dpdgroupuk/mydpd-ui";
import { withTrackProps } from "@dpdgroupuk/react-event-tracker";

import * as S from "~/constants/strings";

const UpdatesAndSave = ({
  isDisabled,
  isReadonly,
  isUserReadonlyPermissions,
  openExportModal,
  handleSubmit,
  onSubmit,
}) => (
  <Main.Footer className="dark main-footer">
    <Button.Toolbar className="w-100">
      <Button
        disabled={isUserReadonlyPermissions}
        variant="light"
        onClick={openExportModal}
      >
        {S.ADDRESS_BOOK_EXPORT}
      </Button>
      <Button
        disabled={isDisabled || isReadonly}
        variant="light"
        onClick={handleSubmit(onSubmit)}
      >
        {S.SAVE}
      </Button>
    </Button.Toolbar>
  </Main.Footer>
);

UpdatesAndSave.propTypes = {
  onSubmit: PropTypes.func,
  isDisabled: PropTypes.bool,
  isReadonly: PropTypes.bool,
  analyticsMetaDate: PropTypes.any,
  isUserReadonlyPermissions: PropTypes.bool,
  openExportModal: PropTypes.func,
  handleSubmit: PropTypes.func,
};

export default compose(
  withTrackProps(props => ({
    onSubmit: props?.analyticsMetaDate?.ON_CLICK_SAVE,
  }))
)(UpdatesAndSave);
